import { createReducer, on } from "@ngrx/store";
import { initialTransferLearnerState, TransferLearnerState } from "./transfer-learner.state";
import { FindLearnerDetails, FindLearnerDetailsError, FindLearnerDetailsSuccess, GetAssignedOrganisation, GetAssignedOrganisationError, GetAssignedOrganisationSuccess, ResetTransferLearnerState, StartTransfer, StartTransferError, StartTransferSuccess, SubmitTransferCentreRequest, SubmitTransferCentreRequestError, SubmitTransferCentreRequestSuccess, SubmitTransferRequest, SubmitTransferRequestError, SubmitTransferRequestSuccess, UndoTransfer, UndoTransferError, UndoTransferSuccess } from "./transfer-learner.actions";

export const TransferLearnerReducers = createReducer(
  initialTransferLearnerState,
  on(SubmitTransferRequest, (state): TransferLearnerState => {
    return {
      ...state,
      loading: true,
      submitTransferError: null,
      submitTransferResponse: null
    };
  }),
  on(SubmitTransferRequestSuccess, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      submitTransferResponse: action.response
    };
  }),
  on(SubmitTransferRequestError, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      submitTransferError: action.error
    };
  }),
  on(FindLearnerDetails, (state): TransferLearnerState => {
    return {
      ...state,
      loading: true,
      learnerDetails: null,
      learnerDetailsError: null
    };
  }),
  on(FindLearnerDetailsSuccess, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      learnerDetails: action.response
    };
  }),
  on(FindLearnerDetailsError, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      learnerDetailsError: action.error
    };
  }),
  on(GetAssignedOrganisation, (state): TransferLearnerState => {
    return {
      ...state,
      loading: true,
      assignedOrganisation: null,
      assignedOrganisationError: null
    };
  }),
  on(GetAssignedOrganisationSuccess, (state, action): TransferLearnerState => { 
    return {
      ...state,
      loading: false,
      assignedOrganisation: action.response
    };
  }),
  on(GetAssignedOrganisationError, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      assignedOrganisationError: action.error
    }
  }),
  on(StartTransfer, (state): TransferLearnerState => {
    return {
      ...state,
      loading: true,
      transferResult: false,
      transferError: null
    };
  }),
  on(StartTransferSuccess, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      transferResult: action.result,
    };
  }),
  on(StartTransferError, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      transferError: action.error
    };
  }),
  on(UndoTransfer, (state): TransferLearnerState => {
    return {
      ...state,
      loading: true,
      undoTransferResult: false,
      undoTransferError: null
    };
  }),
  on(UndoTransferSuccess, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      undoTransferResult: action.result,
    };
  }),
  on(UndoTransferError, (state, action): TransferLearnerState => {
    return {
      ...state,
      loading: false,
      undoTransferError: action.error
    };
  }),
  on(ResetTransferLearnerState, (_): TransferLearnerState => {
    return initialTransferLearnerState;
  }),
  on(SubmitTransferCentreRequest, (state): TransferLearnerState => {
    return {
      ...state,
      loadingTransferCentre: true,
      submitTransferError: null,
      submitTransferResponse: null
    };
  }),
  on(SubmitTransferCentreRequestSuccess, (state, action): TransferLearnerState => {
    return {
      ...state,
      loadingTransferCentre: false,
      submitTransferResponse: action.response
    };
  }),
  on(SubmitTransferCentreRequestError, (state, action): TransferLearnerState => {
    return {
      ...state,
      loadingTransferCentre: false,
      submitTransferError: action.error
    };
  }),

)